import {Point} from './Point';

/**
 * This is a generic rectangle object.
 */
export class Rectangle {
  constructor (left, top, width, height) {
    this.setxywh(left, top, width, height);
  }

  get cx () {
    return this.x + this.w / 2;
  }

  get cy () {
    return this.y + this.h / 2;
  }

  setxy (x = 0, y = 0) {
    this.x = Number(x);
    this.y = Number(y);

    return this;
  }

  setxywh (x, y, w = 0, h = 0) {
    this.setxy(x, y);
    this.w = Number(w);
    this.h = Number(h);

    return this;
  }

  set (cp, cs) {
    return this.setxywh(cp.x, cp.y, cs.w, cs.h);
  }

  setRect (rect) {
    return this.setxywh(rect.x, rect.y, rect.w, rect.h);
  }

  offset (offsetX, offsetY) {
    this.x += Number(offsetX);
    this.y += Number(offsetY);
    return this;
  }

  scale (scale) {
    this.x *= Number(scale);
    this.y *= Number(scale);
    this.w *= Number(scale);
    this.h *= Number(scale);
    return this;
  }

  clone () {
    return new Rectangle().setRect(this);
  }

  /**
     * Converts coordinates to a rectangle drawn from top-left to bottom-right
     */
  normalize () {
    if (this.h < 0) {
      this.h = -this.h;
      this.y -= this.h;
    }
    if (this.w < 0) {
      this.w = -this.w;
      this.x -= this.w;
    }
    return this;
  }

  get area () {
    return this.w * this.h;
  }

  /**
     * Return the rectangle as a list of coordinate points [TL, TR, BR, BL].
     */
  toPointArray () {
    return [
      new Point(this.x, this.y),
      new Point(this.x + this.w, this.y),
      new Point(this.x + this.w, this.y + this.h),
      new Point(this.x, this.y + this.h)
    ];
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/lib/objects/Rectangle.js